




import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import Vditor from 'vditor'

@Component
export default class MarkdownPreviewer extends Vue {
  text = ''

  @Prop({ default: '' })
  readonly value!: string

  @Watch('value', { immediate: true })
  update (value: string | null | undefined) {
    this.preview(value || '')
  }

  async preview (value: string) {
    const html = await Vditor.md2html(value, {
      mode: 'dark',
      markdown: {
        linkBase: document.location.pathname
      }
    })
    const doc = document.implementation.createHTMLDocument("New").body
    doc.innerHTML = html
    this.text = doc.textContent || doc.innerText || ''
  }
}
